<template>
  <section class="invitationCnt" v-on:click="sectionClicked" :style="{
    'background-image': (event.welcome.config.bgImg) ? `url(${event.welcome.config.bgImg.imageLg})` : '',
    'background-size': event.welcome.config.bgSize,
    'background-color': event.welcome.config.bgColor,
    'text-align': event.welcome.config.textAlign,
    'align-items': event.welcome.config.vAlign,
    color: event.welcome.config.textColor,
    padding: event.welcome.config.padding,
    display: event.welcome.config.vAlign === 'flex-start' ? 'block' : 'flex',
    'font-family': event.welcome.config.font,
  }">
    <div class="notFound" v-if="!event || !event.welcome || !event.welcome.sectionData
      || event.welcome.sectionData.length < 1">Not Found</div>
    <template v-else>
      <section class="invitationSection section" v-for="(sc, i) in event.welcome.sectionData" :key="`p${i}`">
        <Slider v-if="sc.type === 'Slider'" :section="sc" :event="event"></Slider>
        <ImageHeader v-else-if="sc.type === 'Image Header'" :section="sc" :event="event"></ImageHeader>
        <LeftImage v-else-if="['Left Image', 'Right Image'].includes(sc.type)" :section="sc" :event="event"></LeftImage>
        <BlockArticles v-else-if="sc.type === 'Block Articles'" :section="sc" :event="event"></BlockArticles>
        <IconSlider v-else-if="sc.type === 'Icon Slider'" :section="sc" :event="event"></IconSlider>
        <TextBlock v-else-if="sc.type === 'Text Block'" :section="sc" :event="event"></TextBlock>
        <Gallery v-else-if="sc.type === 'Gallery'" :section="sc" :event="event"></Gallery>
        <Subscription v-else-if="sc.type === 'Subscription'" :section="sc" :event="event"></Subscription>
        <CustomBlock v-else-if="sc.type === 'Custom Block'" :section="sc" :event="event"></CustomBlock>
        <Map v-else-if="sc.type === 'Map'" :section="sc" :event="event"></Map>
        <Form v-else-if="sc.type === 'Form'" :section="sc" :event="event"></Form>
        <SectionImg v-else-if="sc.type === 'Image'" :section="sc" :event="event"></SectionImg>
        <SectionVideo v-else-if="sc.type === 'Video'" :section="sc" :event="event"></SectionVideo>
        <TwoImage v-else-if="sc.type === 'Two Image'" :section="sc" :event="event"></TwoImage>
        <Timeline v-else-if="sc.type === 'Timeline'" :section="sc" :event="event"></Timeline>
      </section>
    </template>
  </section>
</template>

<script>
import Slider from '@/components/Section-Invitation/Slider.vue';
import LeftImage from '@/components/Section-Invitation/LeftImage.vue';
import ImageHeader from '@/components/Section-Invitation/ImageHeader.vue';
import BlockArticles from '@/components/Section-Invitation/BlockArticles.vue';
import IconSlider from '@/components/Section-Invitation/IconSlider.vue';
import Gallery from '@/components/Section-Invitation/Gallery.vue';
import Subscription from '@/components/Section-Invitation/Subscription.vue';
import Map from '@/components/Section-Invitation/Map.vue';
import Form from '@/components/Section-Invitation/Form.vue';
import TextBlock from '@/components/Section-Invitation/TextBlock.vue';
import CustomBlock from '@/components/Section-Invitation/CustomBlock.vue';
import SectionImg from '@/components/Section-Invitation/SectionImg.vue';
import SectionVideo from '@/components/Section-Invitation/SectionVideo.vue';
import TwoImage from '@/components/Section-Invitation/TwoImage.vue';
import Timeline from '@/components/Section-Invitation/Timeline.vue';

export default {
  name: 'home',
  props: ['event'],
  components: {
    Slider,
    LeftImage,
    ImageHeader,
    BlockArticles,
    IconSlider,
    Gallery,
    Subscription,
    Map,
    Form,
    TextBlock,
    CustomBlock,
    SectionImg,
    SectionVideo,
    TwoImage,
    Timeline,
  },
  data() {
    return {
      ch: null,
      loading: true,
    };
  },
  methods: {
    doNothing() {},
    sectionClicked() {},
  },
  mounted() {},
};
</script>

<style scoped lang="scss">
.invitationCnt{
  min-height: calc(100vh - 74px);
  .invitationSection{
    margin: 0 auto;
  }
}
</style>
